// src/services/firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// keep your keys the same, just update storageBucket to the real bucket
const firebaseConfig = {
  apiKey: "AIzaSyAzCT3DVDl5TGpjLv9gA5ufwbTJcugMYks",
  authDomain: "greenspace-1a8c6.firebaseapp.com",
  projectId: "greenspace-1a8c6",
  storageBucket: "greenspace-1a8c6.firebasestorage.app", // <-- was appspot.com
  messagingSenderId: "59777516191",
  appId: "1:59777516191:web:0a2e6514e90f7a9876d8aa",
  measurementId: "G-L9YB5B1Z42"
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1");

// IMPORTANT: pin the exact bucket you set CORS on
export const storage = getStorage(app, "gs://greenspace-1a8c6.firebasestorage.app");
